import { Button, Dialog, DialogActions, DialogTitle } from "@mui/material";
import { useAtom } from "jotai";
import { FC } from "react";
import { modalConfirmLogout } from "../../../atoms/atom";
import { EvolutionService } from "../../../services/EvolutionService";
import { useAlert } from "../../contextProviders/AlertProvider";

const ConfirmLogoutModal: FC = () => {
	const [open, setOpen] = useAtom(modalConfirmLogout);
	const { showAlert } = useAlert();

	return (
		<Dialog
			open={open}
			onClose={() => setOpen(false)}
			id='modal-logout-whatsapp'
		>
			<DialogTitle>Deseja desconectar o WhatsApp da aplicação?</DialogTitle>
			<DialogActions>
				<Button id="close-logout" onClick={() => setOpen(false)}>
					Fechar
				</Button>
				<Button variant="contained" color="error" id="confirm-logout" onClick={logout}>
					Desconectar
				</Button>
			</DialogActions>
		</Dialog>
	);

	async function logout() {
		await new EvolutionService().logout();
		showAlert("WhatsApp desconectado com sucesso!");
		setOpen(false);
	}
}

export default ConfirmLogoutModal;